import { useMemo } from "react";
import { useLocation } from "react-router-dom";

export const useQueryParams = () => {
    const location = useLocation();

    return useMemo(() => {
        // TODO: Override 'get' to have a 'default' param?
        return new URLSearchParams(location.search);
    }, [location.search]);
};
